import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'gfi-gff-nb-parts',
    templateUrl: './gfi-gff-nb-parts.component.html',
    styleUrls: ['./gfi-gff-nb-parts.component.scss'],
    standalone: false
})
export class GfiGffNbPartsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;
  partPrice: number;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.partPrice = pledge?.products?.[0]?.parameters?.gfiGffPartPrice;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  get investmentAmount() {
    const data = this.products?.value;
    const partPrice = data?.[0]?.parameters?.gfiGffPartPrice;

    const amount = data?.reduce((acc, product) => {
      return acc + product?.parameters?.gfiGffNbParts * partPrice;
    }, 0);

    return {
      display: 'success',
      icon: 'success',
      text: `Correspondant à un investissement total de ${amount} €`,
    };
  }
  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
